import { render, staticRenderFns } from "./SignupModalSuccess.vue?vue&type=template&id=b3e42228&scoped=true"
import script from "./SignupModalSuccess.vue?vue&type=script&lang=js"
export * from "./SignupModalSuccess.vue?vue&type=script&lang=js"
import style0 from "./SignupModalSuccess.vue?vue&type=style&index=0&id=b3e42228&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3e42228",
  null
  
)

export default component.exports